module.exports = __webpack_public_path__ + "img/1F1FB-1F1F3.6b6174a3.svg";